import React from 'react';

interface ModelSelectorProps {
  selectedModel: string;
  onModelChange: (model: string) => void;
}

const models = [
  { id: 'gcn', name: 'GCN', description: 'Graph Convolutional Network', icon: '🔵' },
  { id: 'gat', name: 'GAT', description: 'Graph Attention Network', icon: '🟣' },
  { id: 'graphsage', name: 'GraphSAGE', description: 'Graph Sample & Aggregate', icon: '🟢' },
  { id: 'mlp', name: 'MLP', description: 'Multi-Layer Perceptron (Baseline)', icon: '🟡' },
];

export const ModelSelector: React.FC<ModelSelectorProps> = ({ selectedModel, onModelChange }) => {
  return (
    <div className="model-selector">
      <h3>
        <span className="section-icon">🤖</span>
        Select Model
      </h3>
      <div className="model-grid">
        {models.map((model) => (
          <div
            key={model.id}
            className={`model-card ${selectedModel === model.id ? 'selected' : ''}`}
            onClick={() => onModelChange(model.id)}
          >
            <span className="model-icon">{model.icon}</span>
            <div className="model-info">
              <h4>{model.name}</h4>
              <p>{model.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
